"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EulaStatusTypes = {
    fullyAccepted: 0,
    notAccepted: 1,
    canadaAddendumNeeded: 2,
    canadaAddendumDeferred: 3
};
